// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"ILd2M","infoButton":"j9d6R"};